import {Component, OnInit, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {EmailConfirmationService} from './services/email-confirmation.service';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.css'],
})

export class EmailConfirmationComponent implements OnInit, AfterViewInit {

  public email: string;
  public token: string;
  public message: string = 'Verarbeitung / processing ...';
  public error: string;
  public success = '';
  public newsletterMessage = '';
  public newsletterStatus = 'not requested';
  private errorMap: {} = {
    'invalid email': 'Die gewählte E-Mail Adresse ist ungültig',
  };

  constructor(private router: Router,
    private route: ActivatedRoute,
    private emailConfirmationService: EmailConfirmationService) {}

  public ngOnInit(): void {
    this.route.queryParams.pipe(map((params) => {
      return params;
    }))
      .subscribe((queryParams) => {
        this.email = queryParams.email;
        this.token = queryParams.token;
      });
  }

  public ngAfterViewInit() {
    this.emailConfirmationService.confirm(this.email, this.token)
      .subscribe(
        (result: any) => {
          console.log("res %o", result);
          this.message = 'E-Mail-Adresse erfolgreich bestätigt. /<br/> Email address successfully confirmed.';
          this.success = 'true';
          this.newsletterStatus = result.newsletter;
          this.newsletterMessage = this.newsletterStatus == 'success' ? 'Newsletter wurde erfolgreich abonniert. /<br/> Newsletter subscribed successfully.' :
          'Newsletter konnte nicht abonniert werden. /<br/> Newsletter could not be subscribed to.';

        },
        (error: Error) => {
          this.message = 'E-Mail-Adresse konnte nicht bestätigt werden. /<br/> Failed to confirm email address.';
          this.success = 'false';

          const errorMessage: string = error.message;

          if (this.errorMap[errorMessage]) {
            this.error = this.errorMap[errorMessage];
            return;
          }

          this.error = errorMessage;
        },
      );
  }

}
